import { post } from '@/utils/examMan/request'

export function fetchToken() {
  return post('/api/common/cos/token')
}
